// extracted by mini-css-extract-plugin
export default {"errorContainer":"Error404_errorContainer__MCRWQ","errorImage":"Error404_errorImage__zTLwz","goHomeButton":"Error404_goHomeButton__oqseu"};